import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _HiringDocumentStage } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { SelectorProcessTypeConstants } from "../../../../config/Componentes/SelectorProcessTypeConstants";
import { BasicButton } from "../../../../../theme/Component/BasicButton";

export interface HiringModalityDocumentSingleSelectResult {
    IDHiringModalityDocument: number;
    Name: string;
}

interface BaseProps {
    label?: string;
    renderLoan?: string;
    IDSelect?: number | number[];
}

interface SingleSelectProps extends BaseProps {
    onChange: (value: HiringModalityDocumentSingleSelectResult) => void;
}


export const EditorHiringModalityDocument = ({ label, onChange, renderLoan }: SingleSelectProps) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_HiringDocumentStage);

    const [valor, setValor] = useState<string>("");
    const [idProceso, setIDProceso] = useState<number>();

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        setValor(renderLoan)
    }, [renderLoan])

    useEffect(() => {
        getLista();
    }, [])

    const returnData = () => {
        if (!bean.IDHiringModalityDocument) {
            toast.error("Requisito de modalidad no valido");
        } else {
            setValor(`${bean.IDHiringModalityDocument} - ${bean.Name}`);

            (onChange as (value: HiringModalityDocumentSingleSelectResult) => void)(bean);

            setModal({ ...modal, view: false });
        }
    };

    const getLista = () => {
        let filter: any = {}
        if (idProceso > 0) filter.ProcessType = idProceso
        instance.getHiringModalityDocumentRender(null, null, filter).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.List)
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: "IDHiringModalityDocument", mask: MASK_NUMBER, visible: false },
        { title: 'Tipo Requerimiento', property: 'LegalRequirementTypeName' },
        { title: 'Requerimiento', property: 'RequirementTypeName' },
        { title: 'Nombre', property: 'Name' },
        { title: 'Descripción', property: 'Description' },
        { title: '¿El Documento Tiene Vencimiento?', property: 'DocumentDefeat', visible: false },
        { title: 'Término en días', property: 'TermInDays' },
        { title: 'Tipo de Término Legal', property: 'TermTypeName' },
        { title: 'Tabla de Retención Documental', property: 'IDLnTrdName' },
    ]

    const [listaResult, setListaResult] = useState<any>([]);
    const clearSelection = () => {
        setValor("");
        (onChange as (value: HiringModalityDocumentSingleSelectResult | null) => void)(null as any);
        setBean({});
    };


    return (
        <>
            <label>{label ?? "Requisito de Modalidad"}</label>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                style={{ minHeight: '35px', cursor: "pointer" }}
                onClick={() => setModal({ ...modal, view: true })}
            >
                {valor ? (
                    <>
                        <span>{valor}</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-link text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                clearSelection();
                            }}
                        >
                            ✕
                        </button>
                    </>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={() => { returnData() }}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectorProcessTypeConstants label='Proceso' idSelector={idProceso} onChange={setIDProceso} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton eventClick={()=>{getLista()}} icon="ri-search-line" children={`Buscar`} useMargin />
                    </div>
                    
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={setBean} />
                    </div>
                </div>
            </Modal>
        </>
    )
}